import getWithToken from './base/get-with-token'

const getNineCustomerTheMostAlertScreenshot = (tenant_id) => getWithToken(`/alerts/nine-customer-the-most-for-screenshot?tenant_id=${tenant_id}`)()

export default getNineCustomerTheMostAlertScreenshot
